export enum ObjectModelPropertyCapability {
  labelable = 1,
  requireable = 2,
  formattable = 3,
  lengthable = 4,
  indexable = 5,
  numericFormattable = 6,
  numericMinMaxable = 7,
  dateMinMaxable = 8,
  linkToRelationable = 9,
  linkToRelationPropertyable = 10,
  derivedValuable = 11,
  autoIncrementable = 12,
  selectable = 13,
  optionRangeRequireable = 14,
  sfSelectable = 15, // can be used in salesforce SELECT
  sfUpdatable = 16, // can be updated with data from salesforce
  readonly = 17, // calculate field that user can't edit manually
  fileAttachable = 18,
  loggable = 19,
  referenceable = 20,
  aggregatable = 21, // can handle functions like SUM, AVERAGE, etc - aggregating data on records in a relationship
  securityMaskable = 22,
  externalIdable = 23,
  permissionEditable = 24,
}
